import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__images_upload } from '@shared/dto/+image/DTO_REQUEST__images_upload';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../generation/STATE__generation';

export const REMOTE__images_use_in_non_custom_collection = createAsyncThunkSafe<DTO__image_asset[] | DTO_RESPONSE__error, DTO_REQUEST__images_upload>(
  ENUM__network_event_client_to_server.IMAGES__USE_IN_NON_CUSTOM_COLLECTION,
  async (request): Promise<any> => {
    return await send_to_server(ENUM__network_event_client_to_server.IMAGES__USE_IN_NON_CUSTOM_COLLECTION, request);
  },
);

export function INIT_REMOTE__images_use_in_non_custom_collection(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__images_use_in_non_custom_collection.pending, (state, action) => {})
    .addCase(REMOTE__images_use_in_non_custom_collection.rejected, (state, action) => {})
    .addCase(REMOTE__images_use_in_non_custom_collection.fulfilled, (state, action: PayloadAction) => {});
}
